import React, { useState } from 'react'
import { FieldError } from 'react-hook-form'
import { StylesConfig } from 'react-select'
import {
	AsyncPaginate,
	reduceGroupedOptions,
	AsyncPaginateProps,
} from 'react-select-async-paginate'

import { inputIsValid } from '@utils/helpers'

type Option = { value: number; label: string }
type Group = { label: string; options: Option[] }
type Additional = { page: number; hasMore: boolean }

interface Props extends AsyncPaginateProps<Option, Group, Additional, true> {
	error?: FieldError
	isTouched?: boolean
}

export default function AsyncSelectSafe(props: Props) {
	const [menuOpen, setMenuOpen] = useState(false)
	const [hasResults, setHasResults] = useState(false)

	const styles: StylesConfig<Option, true, Group> = {
		input: (base) => ({
			...base,
			borderRadius: '6px',
			paddingLeft: '2.5px',
			paddingRight: '2.5px',
			paddingTop: '3.5px',
			paddingBottom: '3.5px',
		}),
		control: (controlStyles) => ({
			...controlStyles,
			borderColor: (() => {
				const isValid = inputIsValid(props.error, props.isTouched)

				if (typeof isValid === 'undefined') {
					return '#D1D5DB !important'
				}

				if (!isValid) {
					return '#F44545 !important'
				}

				return '#15CA71 !important'
			})(),
		}),
		option: (optionStyle, { isFocused }) => ({
			...optionStyle,
			backgroundColor: isFocused ? '#1673FA' : '#fff',
			color: isFocused ? '#fff' : '#000',
		}),
	}

	const loadOptionsIntercept: Props['loadOptions'] = async (
		inputValue,
		loadedOptions,
		additional
	) => {
		const result = await props.loadOptions(
			inputValue,
			loadedOptions,
			additional
		)

		const len = Array.isArray(result.options) ? result.options.length : 0

		setHasResults(len > 0)

		return result
	}

	return (
		<AsyncPaginate
			{...props}
			loadOptions={loadOptionsIntercept}
			reduceOptions={reduceGroupedOptions}
			menuIsOpen={menuOpen}
			styles={styles}
			onMenuOpen={() => setMenuOpen(true)}
			onMenuClose={() => setMenuOpen(false)}
			onKeyDown={(e) => {
				if (e.key === 'Enter' && (!menuOpen || !hasResults)) {
					e.preventDefault()
					e.stopPropagation()
				}
			}}
		/>
	)
}
